<template>
  <div>
    <a-form-model ref="ruleFormRef" :model="detailData" autoComplete="off">
      <a-form-model-item label="加工组织">
        <a-input v-model="detailData.organizationName" disabled />
      </a-form-model-item>
      <a-form-model-item label="工艺路线编码">
        <a-input v-model="detailData.routingCode" disabled />
      </a-form-model-item>
      <a-form-model-item label="工艺路线名称" prop="routingDesc" :rules="[inputRequiredRule]">
        <a-input v-model="detailData.routingDesc" :disabled="!editIs" />
      </a-form-model-item>
      <a-form-model-item label="版本号" prop="version">
        <a-input v-model="detailData.version" disabled />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="routingStatus" :rules="[baseRequiredRule]">
        <a-select v-model="detailData.routingStatus" style="width: 100%" :disabled="!editIs">
          <a-select-option v-for="item in statusOptions" :key="item.value" :value="item.value">{{
            item.label
          }}</a-select-option> </a-select
        >
      </a-form-model-item>
      <a-form-model-item label="是否默认" prop="defaultIs" :rules="[baseRequiredRule]">
        <a-select v-model="detailData.defaultIs" style="width: 100%" :disabled="!editIs">
          <a-select-option value="Y">是</a-select-option>
          <a-select-option value="N">否</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
    <div class="rule-footer" v-if="editIs">
      <a-space>
        <a-button v-hasPermi="['bom:bomRoutingHeaderCc:edit']" type="primary" @click="onSaveBase" :loading="btnLoading">保存</a-button>
        <!-- <a-button @click="onClosePage">取消</a-button> -->
      </a-space>
    </div>
  </div>
</template>

<script>
import { STATUS_CODE } from '../enums.js'
import {
  apiUpdateStandardProcess
} from '@/api/mes/basedata/standardProcessNew'
import pick from 'lodash/pick'

export default {
  name: 'BaseForm',
  components: {},
  props: {
    detailData: {
      type: Object,
      default: () => ({})
    },
    editIs: {
      type: Boolean,
      default: true
    }
  },
  data() {
    this.inputRequiredRule = { required: true, message: ' ', whitespace: true }
    this.baseRequiredRule = { required: true, message: ' ' }
    return {
      btnLoading: false
    }
  },
  computed: {
    statusOptions() {
      return Object.values(STATUS_CODE)
    }
  },
  methods: {
    onSaveBase() {
      this.$refs.ruleFormRef.validate(valid => {
        if(valid) {
          this.btnLoading = true;
          const params = pick(this.detailData, ['id', 'routingDesc', 'version', 'routingStatus', 'routingCode', 'organizationName', 'organizationCode', 'defaultIs'])
          apiUpdateStandardProcess(params).then(res => {
            if(res.code === 200) {
              this.$message.success('保存成功');
              this.$EventBus.$emit('RefreshStandardProcessNewListEventName', true);
            }
          }).finally(() => {
            this.btnLoading = false;
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.rule-footer {
  position: sticky;
  bottom: 0;
  z-index: 99;
  text-align: center;
}
</style>
